export default {
  PREFIXES: { AUTH: '/auth' },
  URLS: {
    LOGIN: '/login',
    LOGIN_PIN: '/loginPin',
    LOGOUT: '/logout',
    SUBSCRIPTIONS: '/subscriptions',
    TRANSACTIONS: '/transactions',
    UNSUBSCRIBE: '/unsub/:id',
    UNSUBSCRIBE_SHORTEN: '/unsubc/:id',
    UNSUBSCRIBE2: '/unsubscribe/:id',
    UNSUBSCRIBEIDENTIFIER: '/unsubx/:id',
    UNSUBSCRIBEIDENTIFIER2: '/unsub_u/:id',
  },
  MERCHANT_URL: '/merchant-and-partners',
  SUBSCRIPTIONS_URL: '/subscriptions',
  CAMPAIGNS_URL: '/campaigns',
  OPERATOR_URL: '/operators',
};
